import { createContext } from 'react';

export const Context = createContext({ command: 'help', setCommand: () => {} });
